import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import fetchData from "../../api/fetchApi";
import Table from "../common/Table";
import PageHeader from "../common/PageHeader";


const StatusPill = ({ status }) => {
  let colorClasses = "bg-gray-100 text-gray-800 border-gray-200";
  if (status === "failed") {
    colorClasses = "bg-red-50 text-red-700 border-red-200";
  } else if (status === "pending") {
    colorClasses = "bg-yellow-50 text-yellow-700 border-yellow-200";
  } else if (status === "paid" || status === "completed" || status === "succeeded") {
    colorClasses = "bg-green-50 text-green-700 border-green-200";
  }

  return (
    <span className={`inline-flex items-center gap-1.5 text-xs px-2 py-1 rounded-full border ${colorClasses}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${
        status === "failed" ? "bg-red-500" :
        status === "pending" ? "bg-yellow-500" :
        (status === "paid" || status === "completed" || status === "succeeded") ? "bg-green-500" : "bg-gray-400"
      }`}></span>
      {status}
    </span>
  );
};

function PaymentsPage() {
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({});
  const [filters, setFilters] = useState({
    id: "",
    gateway: "",
    reference: "",
    amount: "",
    currency: "",
    status: ""
  });

  const fetchPayments = async (page = 1, perPage = 15, filterObj = filters) => {
    setLoading(true);
    setError(null);
    try {
      let query = `finance/payments?page=${page}&per_page=${perPage}`;
      if (filterObj.id) query += `&filter[id]=${encodeURIComponent(filterObj.id)}`;
      if (filterObj.gateway) query += `&filter[gateway]=${encodeURIComponent(filterObj.gateway)}`;
      if (filterObj.reference) query += `&filter[reference]=${encodeURIComponent(filterObj.reference)}`;
      if (filterObj.amount) query += `&filter[amount]=${encodeURIComponent(filterObj.amount)}`;
      if (filterObj.currency) query += `&filter[currency]=${encodeURIComponent(filterObj.currency)}`;
      if (filterObj.status) query += `&filter[status]=${encodeURIComponent(filterObj.status)}`;
      const data = await fetchData(query);
      setPayments(data.data || []);
      setPagination({
        links: data.links,
        meta: data.meta,
      });
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء جلب البيانات");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments(1, 15, filters);
    // eslint-disable-next-line
  }, [filters]);

  const onFilter = () => {
    fetchPayments(1, 15, filters);
  };

  const columns = [
    { header: "ID", accessor: "id" },
    { header: "البوابة", accessor: "gateway" },
    { header: "المرجع", accessor: "reference" },
    { header: "المبلغ", accessor: "amount" },
    { header: "العملة", accessor: "currency" },
    { header: "الحالة", accessor: "status", render: row => <StatusPill status={row.status} /> },
    { header: "تاريخ الإنشاء", accessor: "created_at" },
  ];

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir="rtl">
      <PageHeader title="المدفوعات" total={pagination.meta?.total}>
        <Link
          to="/finance/payments/initiate"
          className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700"
        >
          بدء عملية دفع جديدة
        </Link>
      </PageHeader>
      <Table
        columns={columns}
        rows={payments}
        filters={filters}
        setFilters={setFilters}
        onFilter={onFilter}
        pagination={pagination}
        onPageChange={(page, perPage) => fetchPayments(page, perPage, filters)}
      />
      {loading && <div className="text-center mt-4">جاري التحميل...</div>}
      {error && <div className="text-red-600 text-center mt-4">{error}</div>}
    </div>
  );
}

export default PaymentsPage;
